/*
 * Seasonal engraving (G1.7). Markup: snippets/engraving-field.liquid.
 *
 * Material "None"  -> the product form submits normally (no engraving).
 * Material chosen  -> text is required (trimmed, 1..max chars). One request adds
 *   the selected variant with the shopper's quantity, plus the engraving add-on
 *   with the same quantity. Both lines share a private "_engraving_pair" id so the
 *   cart can keep them together (snippets/amp-slide-cart.liquid).
 */
(function () {
  'use strict';

  function setup(root) {
    if (root.dataset.engravingReady) return;
    root.dataset.engravingReady = '1';

    var form = document.getElementById(root.dataset.productForm);
    var max = parseInt(root.dataset.max, 10) || 10;
    var textWrap = root.querySelector('[data-engraving-text-wrap]');
    var input = root.querySelector('[data-engraving-text]');
    var count = root.querySelector('[data-engraving-count]');
    var error = root.querySelector('[data-engraving-error]');
    var notice = root.querySelector('[data-engraving-notice]');
    var materialLabel = root.querySelector('[data-engraving-material-label]');
    if (!form || !input) return;
    var busy = false;

    function material() {
      var checked = root.querySelector('[data-engraving-material]:checked');
      return checked ? checked.value : 'None';
    }

    function showError(message) {
      error.textContent = message;
      error.hidden = !message;
      input.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    function refresh() {
      var on = material() !== 'None';
      materialLabel.textContent = material();
      textWrap.hidden = !on;
      notice.hidden = !on;
      if (!on) showError('');
      count.textContent = input.value.length + ' / ' + max;
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-engraving-material]')) refresh();
    });
    input.addEventListener('input', function () {
      if (input.value.length > max) input.value = input.value.slice(0, max);
      showError('');
      refresh();
    });

    // Slide Cart adds to cart from a delegated CLICK handler on the submit button
    // (and cancels the submit), so intercept the click too. Capture phase on
    // window runs before Slide Cart's and the theme's own handlers.
    function isOurSubmit(e) {
      if (e.type === 'submit') return e.target === form;
      var button = e.target.closest && e.target.closest('[type="submit"]');
      return !!button && (button.form === form || form.contains(button));
    }

    function onAddToCart(e) {
        if (!isOurSubmit(e) || material() === 'None') return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (busy) return;

        var text = input.value.trim();
        if (!text) {
          showError('Please enter your engraving text.');
          input.focus();
          return;
        }
        if (text.length > max) {
          showError('Engraving text can be at most ' + max + ' characters.');
          input.focus();
          return;
        }

        var variantInput = form.querySelector('.product-variant-id') || form.querySelector('[name="id"]');
        var variantId = variantInput && variantInput.value;
        if (!variantId) return;
        var qtyInput = document.querySelector('input[name="quantity"][form="' + form.id + '"]') || form.querySelector('input[name="quantity"]');
        var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);

        // Keep any other line-item properties the product form carries (e.g. Finish).
        var baseProperties = {};
        new FormData(form).forEach(function (value, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m) baseProperties[m[1]] = value;
        });
        var pair = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
        baseProperties._engraving_pair = pair;

        var variantTitle = '';
        try {
          var titles = JSON.parse(root.querySelector('[data-engraving-variants]').textContent);
          variantTitle = titles[String(variantId)] || '';
        } catch (err) {}
        if (variantTitle === 'Default Title') variantTitle = '';

        var submitButton = form.querySelector('[type="submit"]');
        busy = true;
        if (submitButton) submitButton.setAttribute('aria-disabled', 'true');

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(variantId), quantity: quantity, properties: baseProperties },
              {
                id: Number(root.dataset.engravingVariant),
                quantity: quantity,
                properties: {
                  'Engraving Text': text,
                  Material: material(),
                  'Engraving For': root.dataset.productTitle + (variantTitle ? ' - ' + variantTitle : ''),
                  _engraving_pair: pair
                }
              }
            ]
          })
        })
          .then(function (r) {
            return r.json().then(function (body) {
              if (!r.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
              return body;
            });
          })
          .then(function () {
            input.value = '';
            refresh();
            if (typeof window.SLIDECART_UPDATE === 'function') {
              window.SLIDECART_UPDATE();
              if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (err) {
            showError(err.message);
          })
          .then(function () {
            busy = false;
            if (submitButton) submitButton.removeAttribute('aria-disabled');
          });
    }
    window.addEventListener('click', onAddToCart, true);
    window.addEventListener('submit', onAddToCart, true);

    refresh();
  }

  function init() {
    document.querySelectorAll('[data-engraving]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
